import { TFunction } from "@Context/TranslationContext/TranslationContext";
import { Warning as WarningAPI } from "@MeteoApi/models/Warning";
import Frost from "@Resources/images/iconsets/weather_warnings/frost.svg?react";
import Rain from "@Resources/images/iconsets/weather_warnings/heavyrain.svg?react";
import Ice from "@Resources/images/iconsets/weather_warnings/icy.svg?react";
import Snow from "@Resources/images/iconsets/weather_warnings/snow.svg?react";
import Lightning from "@Resources/images/iconsets/weather_warnings/thunderstorms.svg?react";
import Warning from "@Resources/images/iconsets/weather_warnings/warning.svg?react";
import Wind from "@Resources/images/iconsets/weather_warnings/wind.svg?react";

export const priorityColor = (
  t: TFunction,
): Record<
  WarningAPI["priority"],
  { icon: string; bg: string; legendText: string; a11yLegendText: string }
> => ({
  1: {
    icon: "#092b49",
    bg: "m:bg-special-warning-yellow",
    legendText: t("forecast.lowDanger"),
    a11yLegendText: t("forecast.a11yLowDanger"),
  },
  2: {
    icon: "#ffffff",
    bg: "m:bg-special-warning-orange",
    legendText: t("forecast.mediumDanger"),
    a11yLegendText: t("forecast.a11yMediumDanger"),
  },
  3: {
    icon: "#ffffff",
    bg: "m:bg-special-warning-red",
    legendText: t("forecast.highDanger"),
    a11yLegendText: t("forecast.a11yHighDanger"),
  },
});

export type WarningType = WarningAPI["type"] | 0;
export const warningIcon: Record<
  WarningType,
  React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >
> = {
  0: Warning,
  1: Frost,
  2: Lightning,
  3: Ice,
  4: Rain,
  5: Snow,
  6: Wind,
};
